import { deleteNewsItem, getFeedsComments } from '@/pages/opinion/services';
import { FilterKeys } from '@op/components/FilterCommon/types';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { useState, useMemo, useEffect } from 'react';
import { Modal } from 'tea-component';
import { useIntl } from 'umi';
export function useDeleteNews({ params, successCallback }: any) {
  const { formatMessage } = useIntl();

  function deleteNews(newsItem: any) {
    if (newsItem.md5_uni) {
      Modal.confirm({
        message: formatMessage({ id: 'Do you want to delete this article?' }),
        description: '',
        okText: formatMessage({ id: 'Confirm' }),
        cancelText: formatMessage({ id: 'Cancel' }),
        onOk: () => {
          deleteNewsItem({
            edition_unified_id: params.edition_unified_id,
            md5_uin: newsItem.md5_uni,
            release_time: newsItem.release_time,
            insert_time: newsItem.insertTime,
          }).then(() => {
            successCallback(newsItem);
          });
        },
      });
    }
  }

  return {
    deleteNews,
  };
}

export function useNewsInfo({ params, beginRequest, otherParams = {} }: any) {
  const [list, setList] = useState<any>([]);
  const { loading, wrapperRequest } = useCancelRequestHook();
  const getFeedsCommentList = () => {
    beginRequest?.();
    setList([]);
    wrapperRequest((cancelFunc) =>
      getFeedsComments(
        {
          ...params,
          ...otherParams,
        },
        cancelFunc,
      ).then((data: { news_detail_info: any }) => {
        setList(data.news_detail_info);
      }),
    );
  };

  useEffect(() => {
    getFeedsCommentList();
  }, [params]);

  const { deleteNews } = useDeleteNews({
    params,
    successCallback: getFeedsCommentList,
  });

  return {
    list,
    loading,
    deleteNews,
  };
}

export function filterIEGGPr() {
  const [showIEGGPr, setShowIEGGPr] = useState<boolean>(true);
  function backCond(data: any) {
    if (!data?.news_data_source) {
      setShowIEGGPr(true);
      return;
    }
    setShowIEGGPr(data.news_data_source?.includes('IEGG PR') || false);
  }

  const renderExcludeFilter: Array<FilterKeys> = useMemo(() => {
    if (!showIEGGPr) {
      return ['newsUVPM', 'newsDataSource', 'newsCoverageType', 'newsBate'];
    }
    return [];
  }, [showIEGGPr]);

  return { showIEGGPr, backCond, renderExcludeFilter };
}
